export const apiUrl = "https://formsportal.freightways.makerdesign.co.nz";

export const tokenName = "GANYMEDE_TOKEN";
